import { getJsonLdHowTo } from './getJsonLdHowTo';
import { getStructuredFaqs } from './faqs';

const ORGANIZATION_NODE = {
  '@type': 'Organization',
  '@id': 'https://www.spotahome.com/#organization',
  name: 'Spotahome',
  url: 'https://www.spotahome.com',
  sameAs: [
    'https://www.facebook.com/Spotahome',
    'https://twitter.com/spotahome',
    'https://www.linkedin.com/company/spotahome',
    'https://www.instagram.com/spotahome',
    'https://en.wikipedia.org/wiki/Spotahome'
  ]
};

export const getJsonLdGraph = req => {
  // eslint-disable-next-line no-unused-vars
  const { '@context': _c1, ...howToNode } = getJsonLdHowTo(req);

  // eslint-disable-next-line no-unused-vars
  const { '@context': _c2, ...faqPageNode } = getStructuredFaqs(req.trans);

  return {
    '@context': 'https://schema.org',
    '@graph': [ORGANIZATION_NODE, howToNode, faqPageNode]
  };
};
